import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/companyLogo.svg'


const _hoisted_1 = {
  class: "flex align-items-center justify-content-center bg-cover h-screen",
  style: {"background-image":"url('./img/loginBackground.jpg')","background-size":"cover","background-position":"center center"}
}
const _hoisted_2 = {
  class: "p-6 shadow-6 text-center",
  style: {"border-radius":"12px","background-color":"rgba(66, 60, 60, 0.4)","color":"rgba(255, 255, 255, 0.8)","min-width":"40%"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "100",
  style: {"opacity":"0.3"},
  alt: "LLPGROUP"
}, null, -1)

import { ref, onMounted } from "vue";
import router from "@/router";
import store from "@/store";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const loginDetails = ref({
  user: "",
  password: "",
});

onMounted(() => {
  logout();
});

function login() {
  axios
    .post("/api/login", loginDetails.value)
    .then((res) => {
      console.log("LOGIN: ", res.data);
      store.commit("setUser", res.data);
      router.push("/main");
    })
    .catch((err) => {
      console.log(err);
    });
}

function logout() {
  axios
    .get("/api/logout")
    .then((res) => {
      console.log("LOGOUT: ", res.data);
    })
    .catch((err) => {
      console.log(err);
    });
}

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_InputText, {
        modelValue: loginDetails.value.user,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginDetails.value.user) = $event)),
        type: "text",
        class: "appearance-none border-none p-3 w-full outline-none text-xl block mb-4 bg-white-alpha-10 text-white-alpha-60",
        style: {"border-radius":"30px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_InputText, {
        modelValue: loginDetails.value.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginDetails.value.password) = $event)),
        type: "password",
        class: "appearance-none border-none p-3 w-full outline-none text-xl mb-4 bg-white-alpha-10 text-white-alpha-60",
        style: {"border-radius":"30px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_Button, {
        type: "button",
        class: "justify-content-center appearance-none border-none p-3 w-full outline-none text-xl mb-4 font-medium w-12rem bg-white-alpha-30 hover:bg-white-alpha-40 active:bg-white-alpha-20 text-white-alpha-80 cursor-pointer transition-colors transition-duration-150",
        style: {"border-radius":"30px"},
        onClick: login
      }, {
        default: _withCtx(() => [
          _createTextVNode("Sign In")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})